import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const BlogWizard = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <rect
          width="240"
          height="143"
          rx="8"
          fill="#F6F1EB"
        />
        <path
          d="M77 143.309V48.9928C77 47.4034 77.611 45.8791 78.6986 44.7552C79.7862 43.6314 81.2613 43 82.7995 43H158.192C159.731 43 161.206 43.6314 162.293 44.7552C163.381 45.8791 163.992 47.4034 163.992 48.9928V143.309"
          fill="white"
        />
        <path
          d="M77 143.309V48.9928C77 47.4034 77.611 45.8791 78.6986 44.7552C79.7862 43.6314 81.2613 43 82.7995 43H158.192C159.731 43 161.206 43.6314 162.293 44.7552C163.381 45.8791 163.992 47.4034 163.992 48.9928V143.309"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M150.303 71.7637H92.4406C91.6716 71.7637 90.934 72.0794 90.3902 72.6413C89.8464 73.2032 89.5409 73.9654 89.5409 74.7601V92.7384C89.5409 93.5331 89.8464 94.2952 90.3902 94.8571C90.934 95.4191 91.6716 95.7348 92.4406 95.7348H150.303C151.072 95.7348 151.81 95.4191 152.354 94.8571C152.897 94.2952 153.203 93.5331 153.203 92.7384V74.7601C153.203 73.9654 152.897 73.2032 152.354 72.6413C151.81 72.0794 151.072 71.7637 150.303 71.7637Z"
          fill="#FFEDBF"
        />
        <path
          d="M150.183 71.7617H92.3206C91.5516 71.7617 90.814 72.0774 90.2702 72.6393C89.7264 73.2013 89.4209 73.9634 89.4209 74.7581V92.7364C89.4209 93.5311 89.7264 94.2933 90.2702 94.8552C90.814 95.4171 91.5516 95.7328 92.3206 95.7328H150.183C150.952 95.7328 151.69 95.4171 152.234 94.8552C152.777 94.2933 153.083 93.5311 153.083 92.7364V74.7581C153.083 73.9634 152.777 73.2013 152.234 72.6393C151.69 72.0774 150.952 71.7617 150.183 71.7617Z"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92 115H153"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92 135H132"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92.4921 61.1211H123.557"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92 126H153"
          stroke="#1E1E1E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
BlogWizard.displayName = 'BlogWizard';
